import styled, { css } from 'styled-components';
import theme from "../theme/theme";

export default styled.span`
  font-family: Ubuntu, serif;

  ${({ type }) => getType(type)}

  ${({ align }) => getAlign(align)}

  ${({ variant }) => getVariant(variant)}

  ${({ weight }) => getWeight(weight)}
`;

const getWeight = (weight) => {
  switch (weight) {
    case 'light':
      return css`
        font-weight: 300;
      `;
    case 'bold':
      return css`
        font-weight: bold;
      `;
    case 'regular':
      return css`
        font-weight: normal;
      `;
  }
};

const getVariant = (variant) => {
  switch (variant) {
    case 'disabled':
      return css`
        color: ${theme.colors['palette-input-disabled-text']};
      `;

    case 'enabled':
      return css`
        color: ${theme.colors['prisma-color-primary']};
      `;

    case 'link':
      return css`
        color: ${theme.colors['palette-input-link-normal']};
      `;

    case 'neutral':
      return css`
        color: ${theme.colors['palette-neutral-n-1']};
      `;

    case 'neutral-2':
      return css`
        color: ${theme.colors['palette-neutral-n-2']};
      `;

    case 'primary':
      return css`
        color: ${theme.colors['palette-primary-p-1-p-1']};
      `;

    case 'primary-2':
      return css`
        color: ${theme.colors['palette-primary-p-2-p-2']};
      `;
    case 'primary-3':
      return css`
        color: ${theme.colors['palette-primary-p-6-p-6']};
      `;
    case 'primary-4':
      return css`
        color: ${theme.colors['palette-primary-p-7-p-7']};
      `;
    case 'white':
      return css`
        color: ${theme.colors['palette-background-cards-white']};
      `;
  }
};
const getAlign = (align) => {
  switch (align) {
    case 'center':
      return css`
        display: block;

        text-align: center;
      `;

    case 'right':
      return css`
        display: block;

        text-align: right;
      `;

    case 'left':
      return css`
        text-align: left;
      `;
  }
};

const getType = (type) => {
  switch (type) {
    case '1':
      return css`
        line-height: 22px;

        font-size: 16px;
      `;

    case '2':
      return css`
        line-height: 20px;

        font-size: 14px;
      `;

    case '3':
      return css`
        line-height: 19px;

        font-size: 13px;
      `;

    case '4':
      return css`
        line-height: 16px;

        font-size: 12px;
      `;

    case '5':
      return css`
        line-height: 14px;

        font-size: 11px;
      `;
    case '6':
      return css`
        line-height: 16px;

        font-size: 10px;
      `;
  }
};
